module.exports = "pegasus/assets/blocks/column-12-tech.png";